import createEmotion from '@emotion/css/create-instance';

export const { css, cache } = createEmotion({
  key: 'clobe',
  container: typeof document === 'undefined' ? undefined : document.body,
});
